import React from "react";
import {
    Datagrid,
    List,
    SimpleShowLayout,
    TextField,
    DateField,
    Filter,
    TextInput,
    BooleanInput,
    BooleanField,
    SelectInput,
    NumberInput,
    ImageField,
    ImageInput,
    NumberField,
    UrlField,
    ArrayField,
    ReferenceField, ArrayInput, SimpleFormIterator,
} from "react-admin";
import ShowView from "../../components/ShowView";
import EditView from "../../components/EditView";
import { AutocompleteArrayInput } from "react-admin";
import {ChatRoles, Markets} from "../../constants/choices";
import {SpecialistCategories, UserFilterRole} from "./userConstants";
import Emoji from "../../components/Emoji";

const UserFilter = (props) => (
  <Filter {...props}>
      <TextInput label="شناسه" source="objectId" />
      <TextInput label="نام" source="name" />
    <TextInput label="شماره تلفن" source="phoneNumber" />
    <TextInput label="ایمیل" source="email" />
    <SelectInput label="دسترسی" choices={UserFilterRole} optionText={"name"} optionValue={"value"} source={"role"} alwaysOn />
  </Filter>
);

export const UserList = (props) => (
  <List {...props} filters={<UserFilter />} perPage={15}>
    <Datagrid rowClick="show">
      <TextField source="objectId" />
      <DateField showTime={true} locales={"fa-IR"} source="registeredDate" />
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
      <TextField source="name" />
      <TextField source="phoneNumber" />
      <BooleanField source="signupCompleted" />
      <BooleanField source="isBlocked" />
      <TextField source="email" />
      <TextField source="countOfSales" label="تعداد خرید های کاربر" />
    </Datagrid>
  </List>
);

export const UserShow = (props) => (
  <ShowView {...props} noEdit={false}>
    <SimpleShowLayout>
      <TextField source="objectId" />
      <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
      <TextField source="phoneNumber" />
      <TextField source="name" />
      <BooleanField source="signupCompleted" />
      <BooleanField source="isBlocked" />
      <DateField showTime={true} locales={"fa-IR"} source="registeredDate" />
      <NumberField source="walletBalance" />
      <TextField source="weight" />
      <DateField showTime={true} locales={"fa-IR"} source="birthdate" />
      <TextField source="averagePeriodLength" />
      <TextField source="averageCycleLength" />
      <TextField source="averagePredictedCycleLength" />
      <TextField source="irregularityStartDay" />
      <TextField source="irregularityEndDay" />
      <TextField source="averageIrregularityCycleLength" />
      <TextField source="lastPeriodStartDate" />
      <TextField source="lastPeriodEndDate" />
      <TextField source="minimumCycleLength" />
      <TextField source="maximumCycleLength" />
      <TextField source="firstNextPeriodStartDate" />
      <TextField source="nearestPeriodOvulation" />
      <TextField source="numberOfPeriods" />
      <BooleanField source="specialistBusy" />
      <BooleanField source="specialistActive" />
      <NumberField source="specialistExperienceYear" />
      <TextField source="medicalNumber" />
      <NumberField source="specialistPriorityOrder" />
      <TextField source="description" />
      <ImageField source="avatarUrl" />
      <UrlField source="avatarUrl" />
      <TextField source="market" />
      <TextField source="roleDescription" />
      <TextField source="role" />
      <TextField source="sex" />
      <TextField source="userGoal" />
      <TextField source="deviceInfo" />
      <BooleanField source="showClinicButton" label="نمایش دکمه کلینیک" />

      <ArrayField source="invoice">
        <Datagrid>
          <ReferenceField link="show" label="عنوان" source="objectId" reference="invoice">
            <TextField source="title" />
          </ReferenceField>
          <NumberField source="price" />
          <BooleanField source="completed" />
          <BooleanField source="refundedToWallet" />
          <BooleanField source="refundedToCash" />
          <TextField source="sku" />
          <TextField source="status" />
          <TextField source="phoneNumber" />
          <TextField source="gateway" />
          <TextField source="market" />
          <DateField showTime={true} locales={"fa-IR"} source="createdAt" />
          <DateField showTime={true} locales={"fa-IR"} source="updatedAt" />
        </Datagrid>
      </ArrayField>

        <ArrayField source="adminSpecialistCategories">
            <Datagrid>
                <TextField source="category" />
            </Datagrid>
        </ArrayField>
    </SimpleShowLayout>
  </ShowView>
);

export const UserEdit = (props) => (
  <EditView {...props}>
    <TextField source="phoneNumber" />
    <TextInput source="name" />
    <AutocompleteArrayInput source="role" choices={ChatRoles} />
    <TextInput source="roleDescription" />
    <BooleanInput source="isBlocked" />
    <NumberInput source="walletBalance" />
    <BooleanInput source="specialistBusy" />
    <BooleanInput source="showClinicButton" label="نمایش دکمه کلینیک" />
    <BooleanInput source="specialistActive" />
    <NumberInput source="specialistExperienceYear" />
    <TextInput source="medicalNumber" />
    <NumberInput source="specialistPriorityOrder" />
    <Emoji source="description" />
    <ImageInput source="files" label="تصویر پروفایل" accept="image/*">
      <ImageField source="src" title="title" />
    </ImageInput>
    <TextInput source="avatarUrl" />
      <ArrayInput source="adminSpecialistCategories">
          <SimpleFormIterator>
              <SelectInput source="category" choices={SpecialistCategories} />
          </SimpleFormIterator>
      </ArrayInput>
  </EditView>
);
